import comp from "./TagStudents";
export default comp;
